import { Injectable } from "@angular/core";
import { Events } from "ionic-angular";
import { AuthenticationModel, CpConfigurableFormProvider, CustomerAppProvider, CustomFieldsProvider, EncryptStorage, EncryptStorageEvent, ItemsTypesProvider, logger, OrganizationConverter, OrganizationDetailsModel, OrganizationEndPoints, SpacesProvider, WorkItemsStatusProvider, } from "../..";
import { MessengerProvider } from "../messenger/messenger-provider";
var OrganizationDetailsProvider = /** @class */ (function () {
    function OrganizationDetailsProvider(_organizationEndPoints, _model, _messengerProvider, _customerAppProvider, _authModel, _storage, _events, _customFieldsProvider, _cpConfigurableFormProvider, _spacesProvider, _workItemsStatusProvider, _itemsTypesProvider) {
        this._organizationEndPoints = _organizationEndPoints;
        this._model = _model;
        this._messengerProvider = _messengerProvider;
        this._customerAppProvider = _customerAppProvider;
        this._authModel = _authModel;
        this._storage = _storage;
        this._events = _events;
        this._customFieldsProvider = _customFieldsProvider;
        this._cpConfigurableFormProvider = _cpConfigurableFormProvider;
        this._spacesProvider = _spacesProvider;
        this._workItemsStatusProvider = _workItemsStatusProvider;
        this._itemsTypesProvider = _itemsTypesProvider;
        this._ready = false;
        this.bind();
    }
    OrganizationDetailsProvider.prototype.bind = function () {
        var _this = this;
        this._events.subscribe(EncryptStorageEvent.LOCAL_STORAGE_CREATED, function () {
            var _uri = _this._model.uri;
            _this._model.clear(false, true);
            _this._model.load();
            if (_uri != null) {
                _this.load(_uri);
            }
        });
    };
    Object.defineProperty(OrganizationDetailsProvider.prototype, "model", {
        get: function () {
            return this._model;
        },
        enumerable: true,
        configurable: true
    });
    OrganizationDetailsProvider.prototype.load = function (uri) {
        var _this = this;
        this._organizationEndPoints.loadDetails(uri).then(function (res) {
            var organizationDetailsVoData = OrganizationConverter.convertOrganizationDetailsToVo(res);
            _this._model.setId(organizationDetailsVoData.id, true);
            _this._model.setUri(organizationDetailsVoData.uri, true);
            _this._model.setName(organizationDetailsVoData.name, true);
            _this._model.setCustomerPortalActivated(organizationDetailsVoData.customerPortalActivated, true);
            _this._model.setCanViewAnonymously(organizationDetailsVoData.canViewAnonymously, true);
            _this._model.setCanSubmitAnonymously(organizationDetailsVoData.canSubmitAnonymously, true);
            _this._model.setVisibilityPermissions(organizationDetailsVoData.visibilityPermissions, true);
            _this._model.setViewWorkItemsList(organizationDetailsVoData.viewWorkItemsList, true);
            _this._model.setViewMyWorkItems(organizationDetailsVoData.viewMyWorkItems, true);
            _this._model.setCanSubmitFeedback(organizationDetailsVoData.canSubmitFeedback, true);
            _this._model.setRegistrationPolicy(organizationDetailsVoData.registrationPolicy, true);
            _this._model.setLifecycleStatusVisibleForLoggedIn(organizationDetailsVoData.lifecycleStatusVisibleForLoggedIn, true);
            _this._model.setLifecycleStatusVisibleForEveryBody(organizationDetailsVoData.lifecycleStatusVisibleForEveryBody, true);
            _this._model.setFollowingEnabled(organizationDetailsVoData.followingEnabled, true);
            _this._model.setDisplayUserContainers(organizationDetailsVoData.displayUserContainers, true);
            _this._model.setViewPreviouslySubmittedItems(organizationDetailsVoData.viewPreviouslySubmittedItems, true);
            _this._model.setFilterItemsByItemType(organizationDetailsVoData.filterItemsByItemType, true);
            _this._model.setFilterItemsByProject(organizationDetailsVoData.filterItemsByProject, true);
            _this._model.setFilterItemsByStatus(organizationDetailsVoData.filterItemsByStatus, true);
            _this._model.setFileUrl(organizationDetailsVoData.fileUrl, true);
            _this._model.setGeneratedCss(organizationDetailsVoData.generatedCss, true);
            _this._model.setLogo(organizationDetailsVoData.logo, true);
            _this._model.setShowPortalBranding(organizationDetailsVoData.showPortalBranding, true);
            _this._model.setAppearanceOptions(organizationDetailsVoData.appearanceOptions, true);
            _this._messengerProvider.load();
            _this._customerAppProvider.load(res.customerApps);
            _this._ready = true;
            _this._events.publish(OrganizationDetailsProviderEvent.READY, res);
        }).catch(function (err) { return logger.info(err); });
    };
    Object.defineProperty(OrganizationDetailsProvider.prototype, "ready", {
        get: function () {
            return this._ready;
        },
        enumerable: true,
        configurable: true
    });
    OrganizationDetailsProvider.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    OrganizationDetailsProvider.ctorParameters = function () { return [
        { type: OrganizationEndPoints, },
        { type: OrganizationDetailsModel, },
        { type: MessengerProvider, },
        { type: CustomerAppProvider, },
        { type: AuthenticationModel, },
        { type: EncryptStorage, },
        { type: Events, },
        { type: CustomFieldsProvider, },
        { type: CpConfigurableFormProvider, },
        { type: SpacesProvider, },
        { type: WorkItemsStatusProvider, },
        { type: ItemsTypesProvider, },
    ]; };
    return OrganizationDetailsProvider;
}());
export { OrganizationDetailsProvider };
export var OrganizationDetailsProviderEvent;
(function (OrganizationDetailsProviderEvent) {
    OrganizationDetailsProviderEvent["READY"] = "organization-details-provider:ready";
})(OrganizationDetailsProviderEvent || (OrganizationDetailsProviderEvent = {}));
//# sourceMappingURL=organization-details-provider.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/providers/organization/organization-details-provider.js
// module id = 380
// module chunks = 14